import { svg } from 'lit';
export const copy16Svg = svg `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.6154 6H7.38462C6.61991 6 6 6.61991 6 7.38462V13.6154C6 14.3801 6.61991 15 7.38462 15H13.6154C14.3801 15 15 14.3801 15 13.6154V7.38462C15 6.61991 14.3801 6 13.6154 6Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 3V2.38462C10 1.61991 9.38009 1 8.61539 1H2.38462C1.61991 1 1 1.61991 1 2.38462V8.61539C1 9.38009 1.61991 10 2.38462 10H3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
</svg>
`;
//# sourceMappingURL=copy_16.svg.js.map